export enum TransportKind {
	COACH = 'C',
	FLIGHT = 'F',
	WITHOUT = 'W',
	MIX = 'M',
}
